module.exports = __webpack_public_path__ + "static/img/img_ai_01.2cd7ee0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_ai_01.jpg
// module id = vwJZ
// module chunks = 1